import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { FacilityKind, Status } from "../../assets/data/Constants";
import TkStepper from "../../components/atoms/TkStepper";
import TkTitle from "../../components/atoms/TkTitle";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkTable from "../../components/atoms/TkTable";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import {
  BasicMonthlySalaryOfSix,
  EmploymentStatus,
} from "./components/components";
import {
  fakeTableList,
  headList1,
  headList2,
  schema,
  stepperData,
} from "./parts";
import { IAPI_APP007_Response, IAPI_APP008_Request } from "../../type/apiType";
import { httpAPI_APP007, httpAPI_APP008 } from "./api/request";
import _ from "lodash";
import TkButton from "../../components/atoms/TkButton";
import "./_style.scss";
import { IJob_29Props } from "../../type/contextType/businessContext/IJob_29";

/**
 * SCRC060115 共済契約対象外施設への異動情報
 * @return SCRC060115 共済契約対象外施設への異動情報
 */
const SCRC060115 = () => {
  const navigate = useNavigate();
  const [stateInfoList, setStateInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;
  const context = businessState.job_29;
  const checkStatus = !(
    context?.latestApplyStatus === Status["届出待ち"] ||
    context?.latestApplyStatus === Status["差戻し一時保存"]
  );
  const [bodyList1, setBodyList1] = useState<any>();
  const [bodyList2, setBodyList2] = useState<any>();
  const [achievementInfoListData, setAchievementInfoList] = useState<any>({});
  const [resData, setResData] = useState<any>({});
  const [sixMonthList, setSixMonthList] = useState<any>([]);
  const [
    sixMonthsSalaryBeforeTransferList,
    setSixMonthsSalaryBeforeTransferList,
  ] = useState<any>([]);
  const [confirmed, setConfirmed] = useState(false);
  const ref = useRef<any>(null);

  const makeSixMonthSalaryTableList = (
    data: IAPI_APP007_Response | IJob_29Props["transferInfo"],
    sixMonth?: any
  ) => {
    if (!data) return [];
    let sixMonthList: any = [];
    let year = data.year!;
    const months: any = {
      [`${year}04`]: "apr",
      [`${year}05`]: "may",
      [`${year}06`]: "jun",
      [`${year}07`]: "jul",
      [`${year}08`]: "aug",
      [`${year}09`]: "sep",
      [`${year}10`]: "oct",
      [`${year}11`]: "nov",
      [`${year}12`]: "dec",
      [`${year + 1}01`]: "jan",
      [`${year + 1}02`]: "feb",
      [`${year + 1}03`]: "mar",
    };
    data.sixMonthsSalaryBeforeTransferList?.forEach((item) => {
      if (sixMonthList.length >= 6) return;

      let month = (sixMonth ?? (data.achievementInfoList as any)?.[0])[
        months[item.yearMonth!]
      ];
      if (month) {
        if (month === "0" || month === "2") {
          sixMonthList.push(item);
        }
      } else {
        sixMonthList.push(item);
      }
    });

    return sixMonthList;
  };

  const handleInit = async () => {
    // 共済契約対象外施設への異動情報参照API 呼び出し
    try {
      let res = {} as IAPI_APP007_Response | IJob_29Props["transferInfo"];

      if (context?.transferInfo && context?.transferInfo?.staffNo) {
        res = context.transferInfo;
        setConfirmed(res.comfirmedFlg ?? false);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        res = await httpAPI_APP007({
          contractorNo: contractorNo,
          staffNo: context?.staffNo,
          applyId: context?.applyId,
        });
        if (res.resultCd === "I0000") {
          setState({
            ...state,
            errorMsgId: "",
          });
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
          return;
        }
      }

      setResData(res);

      const data1: any[] = [
        [
          {
            children: res.staffNo,
          },
          {
            children: res.staffNameKana,
          },
          {
            children: res.staffNameKanji,
          },
          {
            children: res.staffBirthday,
          },
        ],
      ];

      setBodyList1(data1);

      const data2: any[] = [
        [
          {
            children: (res.bFacilityNo ?? "") + ":" + (res.bFacilityName ?? ""),
          },
          {
            children:
              FacilityKind[res.bFacilityKind as keyof typeof FacilityKind],
          },
        ],
      ];

      setBodyList2(data2);

      let resArr = stateFakeTableList.current;
      resArr.find((item) => item.keyword === "facilityName")!.setDefaultValue =
        res.aFacilityName;
      resArr.find((item) => item.keyword === "facilityName")!.disabled =
        checkStatus;

      resArr.find((item) => item.keyword === "facilityKind")!.setDefaultValue =
        res.aFacilityKind;
      resArr.find((item) => item.keyword === "facilityKind")!.disabled =
        checkStatus;

      const uploadData = resArr.find((item) => item.keyword === "upload")!;
      const targetFile = res.addFileList?.find(
        (item) => item.formKbn === "5" && item.formClass === "2"
      )!;

      if (checkStatus) {
        uploadData.type = "downloadLink";
        uploadData.base64filedata = targetFile?.fileBase64;
        uploadData.dataname = targetFile?.fileName;
        uploadData.downloadBase64 = true;
      } else {
        uploadData.type = "fileUpload";
        uploadData.setDefaultValue = targetFile?.fileBase64
          ? [
              {
                formName: targetFile?.fileName,
                fileBase64: targetFile.fileBase64,
              },
            ]
          : [];
      }

      resArr.find((item) => item.keyword === "lastDay")!.text =
        res.transferDate;

      setStateInfoList([...resArr]);

      setSixMonthList(makeSixMonthSalaryTableList(res));
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleConfirm = () => {
    if (state.errorMsgId) {
      setState({
        ...state,
        errorMsgId: "",
      });
    }
    setSixMonthList(
      makeSixMonthSalaryTableList(resData, achievementInfoListData)
    );
    setConfirmed(true);
  };

  const onCheckAndSubmit = async (data: any) => {
    if (!sixMonthsSalaryBeforeTransferList) return;

    if (!confirmed) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0110E",
      });
      return;
    }
    const isSalaryTableAmtCheckErr = sixMonthsSalaryBeforeTransferList.some(
      (item: any) => Number(item.salaryTableAmt) <= 73999
    );
    if (isSalaryTableAmtCheckErr) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0012E",
      });
      return;
    }
    const paramData: IAPI_APP008_Request = {
      applyId: context?.applyId,
      contractorNo: contractorNo,
      staffNo: resData.staffNo,
      facilityName: data.facilityName,
      facilityKind: data.facilityKind,
      year: resData.year,
      ...achievementInfoListData,
      sixMonthsSalaryBeforeTransferList,
      fileList: [
        {
          serialNo: resData.addFileList?.[0]?.serialNo ?? 1,
          facilityNo: resData.addFileList?.[0]?.facilityNo,
          staffNo: context?.staffNo,
          formKbn: "5",
          formClass: "2",
          fileName: data.upload?.[0]?.formName,
          fileBase64: data.upload?.[0]?.fileBase64,
        },
      ],
    };

    // 共済契約対象外施設への異動情報更新API 呼び出し
    try {
      const res = await httpAPI_APP008({
        ...paramData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRC060013");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 育休確認・登録 ボタン 押下
  const handleParentalLeave = () => {
    let fakeTableData = ref.current.getAllValue();
    let cloneResData = _.cloneDeep(resData);
    delete cloneResData.resultCd;
    cloneResData.aFacilityName = fakeTableData.facilityName;
    cloneResData.aFacilityKind = fakeTableData.facilityKind;
    cloneResData.addFileList = [
      {
        serialNo: resData.addFileList?.[0]?.serialNo ?? 1,
        facilityNo: resData.addFileList?.[0]?.facilityNo,
        staffNo: context?.staffNo,
        formKbn: "5",
        formClass: "2",
        fileName: fakeTableData.upload?.[0]?.formName,
        fileBase64: fakeTableData.upload?.[0]?.fileBase64,
      },
    ];
    cloneResData.achievementInfoList = [
      {
        staffNo: context?.staffNo,
        ...achievementInfoListData,
      },
    ];
    cloneResData.sixMonthsSalaryBeforeTransferList =
      resData.sixMonthsSalaryBeforeTransferList;
    cloneResData.comfirmedFlg = confirmed;

    setBusinessState({
      ...businessState,
      job_29: {
        ...businessState.job_29,
        transferInfo: cloneResData,
      },
    });

    navigate("/SCRC060101", {
      state: { staffNo: resData.staffNo },
    });
  };

  return (
    <Box className="SCRC060115" data-testid="SCRC060115PageForTest">
      {!checkStatus && <TkStepper steps={stepperData} />}

      <TkTitle size="medium">共済契約対象外施設等異動届</TkTitle>

      <TkInfoManual>{labelids.labelid.LBLC060115_01}</TkInfoManual>

      {isKiko && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={
            businessState.common?.contractorNo +
            ":" +
            businessState.common?.contractorName
          }
        />
      )}

      <TkTable
        headList={headList1}
        bodyList={bodyList1}
        headerLeftComponent={<Typography>職員情報</Typography>}
      />

      <TkTable
        headList={headList2}
        bodyList={bodyList2}
        headerLeftComponent={<Typography>勤務していた施設</Typography>}
      />

      <TkFakeTable
        ref={ref}
        list={stateInfoList}
        ruleSchema={schema}
        onCheckAndSubmit={onCheckAndSubmit}
        showButton={false}
      />

      <EmploymentStatus
        data={resData}
        onButtonClick={handleParentalLeave}
        onChange={setAchievementInfoList}
        checkedStatus={checkStatus || confirmed}
      />

      {!checkStatus && (
        <Box className="buttonGroup">
          <TkButton onClick={handleConfirm} disabled={confirmed}>
            ならない月確定
          </TkButton>
        </Box>
      )}

      <BasicMonthlySalaryOfSix
        data={sixMonthList}
        onChange={setSixMonthsSalaryBeforeTransferList}
        checkedStatus={checkStatus || !confirmed}
      />

      <Box className="buttonGroup">
        <TkBackButton
          useBackParam
          navigateParam={{ applyId: context?.applyId }}
        />
        {!checkStatus && (
          <TkButton
            onClick={() => {
              setBusinessState({
                ...businessState,
                job_29: {
                  ...businessState.job_29,
                  transferInfo: {},
                },
              });
              ref.current.submit(false);
            }}
          >
            登録
          </TkButton>
        )}
      </Box>
    </Box>
  );
};

export default SCRC060115;
